// extracted by mini-css-extract-plugin
module.exports = {"Card":"CardItem_Card__1CwGn","DarkCard":"CardItem_DarkCard__3OKfi","Icon":"CardItem_Icon__2FXkG","CardHeader":"CardItem_CardHeader__3B6OZ","CardText":"CardItem_CardText__sqcPN"};